module.exports = __webpack_public_path__ + "img/act_icon_05.7c689e1.png";